import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

interface Props {
  daysGridLength: number;
  i: number;
}

const ExtraDays: FC<Props> = ({ daysGridLength, i }) => {
  
  const locale = useSelector(({theme})=>theme.locale);
  const getWeekDays = () => locale=='en'?[
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
  ]
  :
  [
    'الاثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
    'الأحد',
  ]

  const weekDays = getWeekDays();
  return (
    <Grid
      height='6rem'
      item
      textAlign='center'
      width={`${100 / 7}%`}
      borderTop='none'
      borderRight={() => {
        if (locale!='en'&&i % 7 !== 0) return '1px solid rgb(0, 145, 255, 1)'
      }}
      borderBottom={() => {
        if (!(i > 7 * Math.floor(daysGridLength / 7) - 1))
          return '1px solid rgb(0, 145, 255, 1)';
      }}
      borderLeft={() => {
        if (locale=='en'&&i % 7 !== 0) return '1px solid rgb(0, 145, 255, 1)';
      }}
      key={i}
    >
    </Grid>
  );
};

export default ExtraDays;
